import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KngStatusSelectorFactory } from './kng-status-selector.factory';
import { KngStatusSelectorState } from './definitions';

@Injectable({
	providedIn: 'root'
})
export class KngStatusSelectorService 
{
	private state$: BehaviorSubject<KngStatusSelectorState> = new BehaviorSubject<KngStatusSelectorState>(
		KngStatusSelectorFactory.build()
	);
	get state(): KngStatusSelectorState 
	{
		return this.state$.value;
	}
	get stateChanged(): Observable<KngStatusSelectorState> 
	{
		return this.state$.asObservable();
	}

	public updateState(value: KngStatusSelectorState): void 
	{
		this.state$.next(value);
	}
}
